import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import './AuthPage.css';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const params = new URLSearchParams(window.location.search);
  const notice = params.get('verified')
    ? '¡Correo confirmado! Ya puedes iniciar sesión.'
    : params.get('verify_error')
    ? 'El enlace de confirmación no es válido o ha caducado.'
    : '';

  const handleGoogleLogin = () => {
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:8000';
    window.location.href = `${apiBase}/auth/login`;
  };

  const handleEmailLogin = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);

    try {
      const params = new URLSearchParams();
      params.append('username', email);
      params.append('password', password);
      await axios.post('/auth/token', params);
      // Recarga completa a la raíz, no navigate(): el token acaba de guardarse
      // en la cookie y el estado `user` de App sigue a null, así que una
      // navegación de cliente haría que PrivateRoute rebotase a /login. La
      // recarga vuelve a ejecutar checkUser() y recoge la cookie; el salto al
      // perfil lo hace PostLoginRedirect al ver ?post_login=1.
      window.location.href = '/?post_login=1';
    } catch (err) {
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError('Error al iniciar sesión. Por favor, comprueba tus credenciales.');
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card">
        <h1 className="auth-title">Iniciar sesión</h1>
        <p className="auth-subtitle">Accede a tu cuenta de Almaley</p>

        {notice && (
          <div className={`alert ${params.get('verified') ? 'alert-success' : 'alert-error'}`}>
            {notice}
          </div>
        )}
        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleEmailLogin}>
          <div className="form-group">
            <label>Correo electrónico</label>
            <input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              placeholder="tu@email.com"
            />
          </div>
          <div className="form-group">
            <label>Contraseña</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              placeholder="••••••••"
            />
          </div>
          <button
            type="submit"
            className="btn btn-primary full-width"
            disabled={submitting}
          >
            {submitting ? 'Entrando…' : 'Iniciar sesión'}
          </button>
        </form>

        <div className="auth-divider">o</div>

        <button
          type="button"
          onClick={handleGoogleLogin}
          className="btn btn-google"
        >
          <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
            <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.716v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z"/>
            <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z"/>
            <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z"/>
            <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z"/>
          </svg>
          Continuar con Google
        </button>

        <p className="auth-footer">
          ¿No tienes una cuenta? <Link to="/register">Regístrate</Link>
        </p>
      </div>
    </div>
  );
};

export default Login;
